const React = require("react");
const createReactClass = require("create-react-class");

const ChalkboardData = require("./data/Chalkboard");
const UnderlineView = require("./UnderlineView");
const BALogoText = require("./BALogoText");
const Expandable = require("./Expandable");

const styles = require("./styles/PageChalkboard.css");

module.exports = createReactClass({
	displayName: "PageChalkboard",

	renderQuestionAnswer: function(data, index) {
		return (
			<Expandable
				key={"question-" + index}
				title={<div className={styles.question}>{data.question}</div>}
			>
				<div className={styles.answer}>{data.answer}</div>
			</Expandable>
		);
	},

	renderCurrentAnswers: function(data) {
		const answers = ChalkboardData.current.map((d, i) =>
			this.renderQuestionAnswer(d, i)
		);
		return <div className={styles.answersContainer}>{answers}</div>;
	},

	render: function() {
		//Later we'll want to put previous chalkboards/images below the current ones
		return (
			<div className={styles.main}>
				<div className={styles.jazz} />
				<div className={styles.title}>
					<BALogoText useCaps={true} alwaysLogo={true} />{" "}
					<UnderlineView text={"CHALKBOARD"} />
				</div>
				<div className={styles.contents}>
					<div className={styles.images}>
						<div className={styles.headmasterContainer}>
							<div className={styles.headmasterAspectHackContainer}>
								<img
									className={styles.headmaster}
									alt="BA Headmaster Jason Batterson"
									src={
										global.BASE_URL +
										"assets/images/office/chalkboard/headmaster.svg"
									}
								/>
							</div>
						</div>
						<div className={styles.chalkboardContainer}>
							<div className={styles.chalkboardAspectHackContainer}>
								<img
									className={styles.chalkboard}
									alt="BA Chalkboard Questions"
									src={
										global.BASE_URL +
										"assets/images/office/chalkboard/chalkboard-1.svg"
									}
								/>
							</div>
						</div>
					</div>
					{this.renderCurrentAnswers()}
					<div className={styles.learnMore}>{ChalkboardData.learnMore}</div>
				</div>
			</div>
		);
	},
});
